
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h6>{` `}</h6>
    <h1>{`Disclaimer`}</h1>
    <p>{`Deze Pensioen simulator wordt u aangeboden door Partena Professional in samenwerking met P&V Verzekeringen. Het resultaat van deze simulatie is louter indicatief, Partena Professional aanvaardt hiervoor geen aansprakelijkheid.`}</p>
    <p>{`Hoewel deze tool met de nodige know how en zorg werd ontwikkeld, zal deze nooit een gepersonaliseerd advies kunnen vervangen, aan de verkregen informatie kunnen daarom geen rechten worden ontleend. `}</p>
    <p>{`De bepalingen van `}<u><a parentName="p" {...{
          "href": "https://www.partena-professional.be/nl/disclaimer"
        }}>{`de Partena disclaimer`}</a></u>{` zijn op deze tool van toepassing.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;